// extracted by mini-css-extract-plugin
export var container = "_e2-0";
export var icon = "_e2-1";
export var text = "_e2-2";